import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import cdpService from "../../../apiService/cdp.service";
import Loader from "../../Global/Loader";

const RegistrationMethodChart = ({ filters = {} }) => {
  const [registrationData, setRegistrationData] = useState([
    ["Method", "Total Users"],
  ]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchRegistrationMethodData();
  }, [filters]); // Re-fetch when filters change

  const fetchRegistrationMethodData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await cdpService.getRegistrationMethodChart(filters);

      if (response.data.success) {
        const registrationWithData =
          response.data.data.registrationWithData.map((item) => [
            item.registration_with,
            item.registration_with_count,
          ]);

        setRegistrationData([["Method", "Total Users"], ...registrationWithData]);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const PieHoleOption = {
    pieHole: 0.56,
    is3D: false,
    legend: {
      position: "right",
      alignment: "center",
      textStyle: {
        color: "#233238",
        fontSize: 10,
      },
    },
    chartArea: {
      left: 10,
      right: 10,
      bottom: 20,
      top: 20,
      width: "100%",
      height: "100%",
    },
    colors: ["#FF5733", "#33B5E5", "#99CC00", "#FFBB33", "#AA66CC"], // Custom Colors
  };

  if (loading) return <Loader/>;
  if (error) return <p>Error loading data: {error}</p>;

  return (
    <Chart
      chartType="PieChart"
      width="100%"
      height="350px"
      data={registrationData}
      options={PieHoleOption}
    />
  );
};

export default RegistrationMethodChart;
